import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";
import Logo from "@/components/Logo";

const AdminLogin = () => {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { username: u, password: p });
      localStorage.setItem("mda_token", data.token);
      localStorage.setItem("mda_user", data.username);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-[#0a0a0a] border border-[#2e2e2e] rounded-none text-white px-4 py-3 font-['Exo_2'] focus:border-[#e10600] focus:outline-none focus:ring-1 focus:ring-[#e10600] transition-colors";
  const labelCls = "block font-['Exo_2'] text-[10px] uppercase tracking-[0.25em] text-gray-400 font-bold mb-2";

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      <div className="absolute top-6 left-6">
        <Link to="/" data-testid="back-to-site" className="font-['Exo_2'] text-xs uppercase tracking-[0.3em] text-gray-500 hover:text-white">← Back to site</Link>
      </div>
      <form onSubmit={submit} className="w-full max-w-md bg-[#0f0f0f] border border-[#2e2e2e] p-8 md:p-10">
        <div className="flex flex-col items-center text-center mb-8">
          <Logo className="h-28 w-28 object-contain mb-4" />
          <div className="font-['Anton'] text-chrome text-3xl uppercase leading-none">Mid Del Auto</div>
          <div className="font-['Exo_2'] text-[10px] uppercase tracking-[0.3em] text-gray-500 mt-2">Admin Console</div>
        </div>
        <h1 className="font-['Anton'] text-white text-4xl uppercase leading-none mb-2">Sign In</h1>
        <p className="font-['Exo_2'] text-gray-500 text-sm mb-8">Access bookings and shop management.</p>

        <div className="space-y-5 mb-6">
          <div>
            <label className={labelCls}>Username</label>
            <input data-testid="admin-username-input" required value={u} onChange={(e) => setU(e.target.value)} className={inputCls} placeholder="admin" />
          </div>
          <div>
            <label className={labelCls}>Password</label>
            <input data-testid="admin-password-input" required type="password" value={p} onChange={(e) => setP(e.target.value)} className={inputCls} placeholder="••••••••" />
          </div>
        </div>
        <button type="submit" data-testid="admin-login-button" disabled={loading}
          className="w-full inline-flex items-center justify-center gap-3 bg-[#e10600] hover:bg-[#ff1a1a] disabled:opacity-60 text-white px-8 py-4 uppercase tracking-widest text-sm font-bold transition-colors">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          {loading ? "Signing In…" : "Sign In"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
